<app-breadcrumb></app-breadcrumb>
<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>

<div class="content ms-4 me-4">
    <div class="d-flex justify-content-between roboto-medium">
        <h2 class="roboto-medium title">Control Point Matrix</h2>
        <div class="roboto-medium">
                <img src="./assets/images/file-export-solid.svg" title="Export" (click)="onBtExport()" class="export-icon1 pe-1">
                <img src="assets/images/refresh.svg" title="Refresh" class="refresh-icon" (click)="fetchCPMDashboardData()"/>
            <select [(ngModel)]="selected_position_id" [ngModelOptions]="{standalone: true}"
                class=" mb-1 drpdwn_period b2">
                <option *ngFor="let siteItem of siteItems" [value]="siteItem.position">
                    {{siteItem.description}}
                </option>
            </select>
            <button [ngClass]="{ 'b2 mb-1': !autoPress, 'b3 mb-1': autoPress }" (click)="auto()">AUTO</button>
            <button class="b2 mb-1" (click)="viewComments()">VIEW COMMENTS</button>
            <button class="b2 mb-1" (click)="updateKpi()">UPDATE KPI</button>
            <button class="b2 mb-1 me-0" (click)="updateCriteria()">UPDATE CRITERIA</button>
        </div>
    </div>

    <div class="mt-2">
        <mat-nav-list class="inline">
            <a mat-list-item (click)="Current()" [ngClass]="highlightUnVerified? 'active' : 'inactive' "
                class="menu bar">Current</a>
            <div class="vr"></div>
            <a mat-list-item (click)="History()" [ngClass]="highlightVerified? 'active' : 'inactive' "
                class="menu bar">History</a>
            <div class="vr"></div>
            <a mat-list-item (click)="Statistics()" [ngClass]="highlightTrailer? 'active' : 'inactive' "
                class="menu bar">Statistics</a>
        </mat-nav-list>
        <span *ngIf="!highlightTrailer" class="me-0 ms-0">
            <label class="export-icon me-0">NG</label>
            <input type="text" class="indicators indicator_1" text disabled="true">
            <label class="export-icon">Concern</label>
            <input type="text" class="indicators indicator_2" text disabled="true">
            <label class="export-icon">Fair</label>
            <input type="text" class="indicators indicator_3" text disabled="true">
            <label class="export-icon ms-0">Normal</label>
            <input type="text" class="indicators indicator_4" text disabled="true">
        </span>
    </div>
    <hr>
    <div class="grid-agg px-0" *ngIf="selectedTab == 'current'">
        <ag-grid-angular class="ag-theme-balham grid-items cpmgrid" (gridReady)="onGridReady2($event);"
            (window:resize)="sizeToFit2()" [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDef"
            [rowSelection]="rowSelection" [rowData]="displayCurrentData" [headerHeight]="40" [rowHeight]="rowHeight"
            [floatingFiltersHeight]="40" [suppressCellSelection]="true" [context]="context" [icons]="icons"
            [gridOptions]="gridOptions" [rowClassRules]="rowClassRules" [theme]="'legacy'">
        </ag-grid-angular>
    </div>
    <div class="grid-agg p-0" *ngIf="selectedTab == 'history'">
        <div class="mt-3 mb-3">
            <label class="drpdwn_period_label">Snapshot Date</label>
            <input type="date" onkeypress="return false" class="category ms-3 me-3" (change)="getSnapshotsForDate()"
                [(ngModel)]="snapshotDate">
            <label class="drpdwn_period_label">Snapshots</label>
            <select [(ngModel)]="shapShotId" [ngModelOptions]="{standalone: true}"
                class="drpdwn_period ms-3 drpdwn_period_select" (change)="fetchCPMDashboardDataDropdown()">
                <option *ngFor="let snapShotListone of snapShotList" [value]="snapShotListone.position">
                    {{snapShotListone.description}}
                </option>
            </select>
        </div>
        <ag-grid-angular class="ag-theme-balham grid-items-history cpmgrid" (gridReady)="onGridReady1($event);"
            (window:resize)="sizeToFit1()" [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDef"
            [rowSelection]="rowSelection" [headerHeight]="40" [floatingFiltersHeight]="40"
            [rowClassRules]="rowClassRules" [rowHeight]="rowHeight" [rowData]="displayRowData" [context]="context"
            [icons]="icons" [gridOptions]="gridOptions" [theme]="'legacy'">
        </ag-grid-angular>
    </div>
    <div *ngIf="selectedTab == 'statistics'">
        <div class="mt-3 mb-3 d-flex justify-content-between">
            <div>
                <label class="drpdwn_period_label">Logistics Point</label>
                <select [(ngModel)]="planName" [ngModelOptions]="{standalone: true}" (change)="onLPchange()"
                    class="drpdwn_period ms-3 me-3">
                    <option *ngFor="let eachplantList of plantList" [value]="eachplantList.position">
                        {{eachplantList.description}}
                    </option>
                </select>
                <label class="drpdwn_period_label">From</label>
                <input type="date" [min]="minDate" [max]="maxDate" onkeypress="return false" class="category ms-3" [(ngModel)]="lpDate"
                    (change)="onDatechange()">
            </div>
            <div class="d-flex align-items-center">
                <label class="drpdwn_period_label" style="margin-right: 20px;">KPI </label>
                    <!-- <mat-select 
                      [(ngModel)]="optionalDomiciles"
                      (selectionChange)="onDomicileChange()"
                      multiple
                      [placeholder]="'KPI'"
                     class="mat-sel"
                      style="width:500px;"
                    >
                      <mat-option *ngFor="let option of selectedDomiciles" [value]="option">
                        {{ option.description }}
                      </mat-option>
                    </mat-select> -->
                    <mat-form-field appearance="outline" class="fixed-select">
                        <mat-select [(ngModel)]="optionalDomiciles" multiple [panelWidth]="null" [compareWith]="compareById"
                            (selectionChange)="onDomicileChange()">
                            <div
                                style="display: flex; align-items: center; padding: 8px; position: sticky; top: 0; background: white; z-index: 1;">
                                <mat-checkbox [checked]="isAllSelected(optionalDomiciles, selectedDomiciles)"
                                    [indeterminate]="isIndeterminate(optionalDomiciles, selectedDomiciles)"
                                    (change)="toggleSelectAll($event, 'optionalDomiciles', selectedDomiciles)">
                                </mat-checkbox>
                                <ngx-mat-select-search [formControl]="domicileFilterCtrl" placeholderLabel="Search"
                                    noEntriesFoundLabel="No options found">
                                </ngx-mat-select-search>
                            </div>
                    
                            <div style="max-height: 200px; overflow-y: auto;">
                            <mat-option *ngFor="let d of filteredDomiciles | async" [value]="d">
                                {{ d.description }}
                            </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                   
                      
            </div>
        </div>
        <div class="graph" *ngIf="!hideGraph">
            <canvas baseChart style="display: block;
            height: 300px !important;
            width: 600px !important;"
            [datasets]="lineChartData.datasets"
            [labels]="lineChartData.labels"
            [options]="lineChartOptions"
            [legend]="lineChartLegend"
            [type]="lineChartType">
          </canvas>
        </div>
    </div>

</div>